import {
    saveAs
} from 'file-saver';
import * as pdfform from '../../node_modules/pdfform.js/pdfform.js';
import utilities from '../scripts/utilities';

let membershipForms = {
    gupMembership: function (student, phoneType) {
        let studentName = student.nameFirst + student.nameLast;

        var sourcePDFurl = '/membership_forms_pdfs/ITF_Gup_membership.pdf';

        var xhr = new XMLHttpRequest();
        xhr.open('GET', sourcePDFurl, true);
        xhr.responseType = 'arraybuffer';

        xhr.onload = function () {
            if (this.status == 200) {

                var stateAbbrev = utilities.abbrState(student.state, 'abbr');

                var fields = {};
                fields['FullName'] = [student.nameFirst + " " + student.nameLast];
                if (student.gender === "Male") {
                    fields['Male'] = [true];
                } else {
                    fields['Female'] = [true];
                }
                fields['Address'] = [student.address];
                fields['City'] = [student.city];
                fields['State'] = [stateAbbrev];
                fields['ZipCode'] = [student.zip];
                fields['Phone'] = phoneType === 'phone' ? [student.phone] : [student.cellPhone];
                fields['DateOfBirth'] = [student.dob];
                fields['StartDate'] = [student.startDate];

                var filledpdf = pdfform().transform(this.response, fields);
                var outBlob = new Blob([filledpdf], {
                    type: 'application/pdf'
                });
                var fileName = studentName + '-MembershipForm';

                saveAs(outBlob, fileName + '.pdf');
            } else {
                console.error('Could not retrieve PDF!');
            }
        };

        xhr.send();
    },
    danMembership: function (student, phoneType) {
        let studentName = student.nameFirst + student.nameLast;

        var sourcePDFurl = '/membership_forms_pdfs/ITF_Dan_membership.pdf';

        var xhr = new XMLHttpRequest();
        xhr.open('GET', sourcePDFurl, true);
        xhr.responseType = 'arraybuffer';

        xhr.onload = function () {
            if (this.status == 200) {
                var stateAbbrev = utilities.abbrState(student.state, 'abbr');

                var fields = {};
                fields['FullName'] = [student.nameFirst + " " + student.nameLast];
                if (student.gender === "Male") {
                    fields['Male'] = [true];
                } else {
                    fields['Female'] = [true];
                }
                fields['Address'] = [student.address];
                fields['City'] = [student.city];
                fields['State'] = [stateAbbrev];
                fields['ZipCode'] = [student.zip];
                fields['Phone'] = phoneType === 'phone' ? [student.phone] : [student.cellPhone];
                fields['DateOfBirth'] = [student.dob];

                var filledpdf = pdfform().transform(this.response, fields);
                var outBlob = new Blob([filledpdf], {
                    type: 'application/pdf'
                });
                var fileName = studentName + '-MembershipForm';

                saveAs(outBlob, fileName + '.pdf');
            } else {
                console.error('Could not retrieve PDF!');
            }
        };

        xhr.send();
    },
};

export default membershipForms;